<template>
    <li
        data-top-right-id="notifications"
        class="wrapper"
        @click="$emit('toggle')"
    >
        <a class="nav-link">
            <i class="fas fa-bell"></i>
            <span class="d-lg-none">Notification</span>
            <div v-show="count > 0" class="badge">
                {{ count > 99 ? "99+" : count }}
            </div>
        </a>
    </li>
</template>

<script>
export default {
    computed: {
        count() {
            return this.$store.state?.notification?.count ?? 0;
        }
    },
    watch: {
        count(value) {
            let label = value > 99 ? "99+" : value;

            const removeNumberFromTitle = () => {
                document.title = document.title.replace(/\(.*?\)\s*/, "");
            };

            if (value > 0) {
                removeNumberFromTitle();
                document.title = "(" + label + ") " + document.title;
            } else {
                removeNumberFromTitle();
            }
        }
    },
    mounted() {
        this.$root.$on("settingLoaded", () => {
            this.$store.dispatch("notification/getNotificationCount");
        });
    }
};
</script>

<style lang="scss" scoped>
.wrapper {
    position: relative;
    cursor: pointer;
}
.badge {
    transition: none;
    background: red;
    position: absolute;
    top: -3px;
    right: 0;
    font-size: 0.7em;
}
</style>
